<div class="attr-grid">
  <div class="asset-form-item" *ngFor="let attribute of attributes; trackBy: trackById">
    <ng-template attribute-host
      [dynamicAttribute]="attribute"
      [key]="attribute.definition.id">
    </ng-template>
  </div>
</div>
